import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  props: {
    equipmentId: String,
    month: String,
    year: String,
    type: String,
  },

  data: () => ({
    loading: false,
    startDate: null,
    endDate: null,
    institutionId: null,
    serviceOrderId: {},
    serviceOrders: [],
    serviceOrderType: null,
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
      'Serviços',
    ],
    apiService: new ApiService(),
  }),

  async created() {
    const date = new Date(this.year, this.month, 1)
    this.startDate = new Date(this.year, this.month - 1, 1)
    this.endDate = new Date(this.getLastDay(date))

    this.serviceOrderType =
      this.serviceOrderTypes.indexOf(this.type) < 0
        ? this.serviceOrderType
        : this.serviceOrderTypes.indexOf(this.type)
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.equipmentId && this.equipmentId > 0) {
      this.getEquipment()
    } else {
      const date = new Date(this.year, this.month - 1, 1)
      this.endDate = new Date(this.getLastDay(date))
      this.getOSs()
    }
  },

  components: {},

  methods: {
    close() {
      this.$router.go(-1)
    },

    getItemText(value) {
      return `O.S. n° ${value.number} - ${value.name} - ${this.formartDate(
        value.dateTimeRequest
      )}`
    },

    async getEquipment() {
      this.loading = true
      await this.apiService
        .get(`equipment/${this.institutionId}/${this.equipmentId}`)
        .then((response) => {
          const equipment = response.content
          this.serviceOrders = equipment.serviceOrders.filter(
            (x) =>
              new Date(x.dateTimeRequest) >= this.startDate &&
              new Date(x.dateTimeRequest) <= this.endDate &&
              x.serviceOrderType == this.serviceOrderType
          )
        })
        .catch((err) => {})

      this.loading = false
    },

    async getOSs() {
      this.loading = true

      const model = {
        institutionId: this.institutionId,
        orderType: this.serviceOrderType,
        start: this.startDate,
        end: this.endDate,
      }

      await this.apiService
        .post(`serviceOrder/byPeriod`, model)
        .then((response) => {
          this.serviceOrders = response.content
        })
        .catch((err) => {})

      this.loading = false
    },

    getLastDay(date) {
      return Utils.getLastDay(date)
    },

    formartDate(date) {
      return Utils.dateTime(date)
    },

    serviceOrderSelected() {
      this.$router.push(`/editServiceOrder/${this.serviceOrderId}`)
    },
  },

  watch: {},
}
